export const trans_12_2=[
  {
    id:1,
    english:'My fatcher is going to have a business trip on next week',
    vietnamese:'Bố tôi dự định công tác vào tuần tới',
    user_message:''
  },
  {
    id:2,
    english:'When will you have summer holiday? next month',
    vietnamese:'Khi nào bạn được nghỉ hè? Tháng sau tôi được nghỉ hè',
    user_message:''
  },
  {
    id:3,
    english:'This is awesome because there are volunteer students here',
    vietnamese:'Thật tuyệt vì có các bạn sinh viên tình nguyện ở đây',
    user_message:''
  },
  {
    id:4,
    english:'He had planned to go travelling in summer',
    vietnamese:'Anh ấy có kế hoạch đi du lịch vào mùa hè',
    user_message:''
  }, 
]